module.exports = __webpack_public_path__ + "static/media/14.71dc4b77.png";